import { Request, POST, GET, PUT, DELETE, PATCH } from './base';

const SendOTP = async (payload: any) => await Request('/send-otp', POST, false, payload);

const VerifyOTP = async (payload: any) => await Request('/verify-otp', POST, false, payload);

const ResendOTP = async (payload: any) => await Request('/resend-otp', POST, false, payload);

const FetchTatvaAiToken = async (payload: any) => await Request('/lite2ai', POST, false, payload);

const authRest = {
    SendOTP,
    VerifyOTP,
    ResendOTP,
    FetchTatvaAiToken,
};

export default authRest;